/*********************************************************************************************
 * Initialize the sticky CTA behavior.
 *
 */
function initializeStickyCTA() {
	const classicCTA = document.querySelector("[data-cta]");
	const stickyCTA = document.querySelector("[data-sticky-cta]");
	const stickyTitle = document.querySelector("[data-sticky-title]");
	const mainTitle = document.querySelector("[data-title]");
	const form = document.querySelector(".mm-main-product-grid");

	if (!classicCTA || !stickyCTA) return;

	let ctaObserver, titleObserver, formObserver;

	function getStickyHeight() {
		return stickyCTA ? stickyCTA.offsetHeight : 0;
	}

	function createObservers() {
		if (ctaObserver) ctaObserver.disconnect();
		if (titleObserver) titleObserver.disconnect();
		if (formObserver) formObserver.disconnect();

		const rootMargin = `0px 0px -${getStickyHeight()}px 0px`;

		ctaObserver = new IntersectionObserver(
			(entries) => {
				entries.forEach((entry) => {
					if (!entry.isIntersecting) {
						stickyCTA.classList.remove("mm-none");
					} else {
						stickyCTA.classList.add("mm-none");
					}
				});
			},
			{
				root: null,
				threshold: 0,
				rootMargin: rootMargin,
			}
		);
		ctaObserver.observe(classicCTA);

		if (mainTitle && stickyTitle) {
			titleObserver = new IntersectionObserver(
				(entries) => {
					entries.forEach((entry) => {
						if (!entry.isIntersecting) {
							stickyTitle.classList.remove("mm-none");
						} else {
							stickyTitle.classList.add("mm-none");
						}
					});
				},
				{
					root: null,
					threshold: 0,
					rootMargin: rootMargin,
				}
			);
			titleObserver.observe(mainTitle);
		}

		if (form) {
			formObserver = new IntersectionObserver(
				(entries) => {
					entries.forEach((entry) => {
						if (!entry.isIntersecting) {
							stickyCTA.classList.add("mm-none");
							if (stickyTitle) stickyTitle.classList.add("mm-none");
						}
					});
				},
				{
					root: null,
					threshold: 0,
					rootMargin: rootMargin,
				}
			);
			formObserver.observe(form);
		}
	}

	createObservers();

	window.addEventListener("resize", () => {
		createObservers();
	});
}

/*********************************************************************************************
 * Toggle the custom or variant selector
 *
 */
function toggleCustomOrVariantSelector(selector) {
	const selectors = ["color", "variant"];
	let toggled = false;

	selectors.forEach((sel) => {
		const el = document.getElementById(`custom-select-${sel}`);
		const btn = document.querySelector(`[onclick*="toggleCustomOrVariantSelector('${sel}'"]`);
		if (el) {
			if (sel === selector) {
				// Toggle: si déjà visible, on masque tout
				if (el.style.display === "" || el.style.display === "block") {
					el.style.display = "none";
					if (btn) btn.classList.remove("active");
				} else {
					el.style.display = "block";
					if (btn) btn.classList.add("active");
					toggled = true;
				}
			} else {
				el.style.display = "none";
				if (btn) btn.classList.remove("active");
			}
		}
	});
}

/*********************************************************************************************
 * Open the find in store modal
 *
 */
function mmOpenFindInStore() {
	const header = document.querySelector(".mm-header-container");
	const modal = document.querySelector(".mm-find-in-store-popup-container");
	const html = document.querySelector("html");
	html.classList.toggle("stop-scrolling");
	modal.classList.toggle("open");
	if (modal.classList.contains("open")) {
		header.style.transform = "translateY(-100%)";
	} else {
		header.style.transform = "";
	}
}

/*********************************************************************************************
 * Open the my modal
 *
 */
function mmOpenSizeGuide() {
	const header = document.querySelector(".mm-header-container");
	const modal = document.querySelector(".mm-product-size-guide-container");
	const html = document.querySelector("html");
	html.classList.toggle("stop-scrolling");
	modal.classList.toggle("open");
	if (modal.classList.contains("open")) {
		header.style.transform = "translateY(-100%)";
		var iframeElement = document.getElementById("klaviyo-bis-iframe");
		if (iframeElement && window.getComputedStyle(iframeElement).display !== "none") {
			iframeElement.style.display = "none";
		}
	} else {
		header.style.transform = "";
	}
}

/*********************************************************************************************
 * Initialize the Splide carousel for the reassurance slider.
 *
 */
function mmSlideProductReassurance() {
	var splideElemMain = document.querySelector("#slider-reassurance");

	if (splideElemMain) {
		var main = new Splide(splideElemMain, {
			type: "slide",
			rewind: true,
			pagination: true,
			arrows: false,
			autoplay: true,
			interval: 5000,
			perPage: 1,
		});
		main.mount();
	}
}

/*********************************************************************************************
 * Change the quantity value in the input field and update the related prices.
 *
 * @param {number} delta - The change to apply to the current quantity (e.g., +1 or -1).
 * @param {string} inputId - The ID of the input field where the quantity is adjusted.
 */
function mmChangeQtty(delta, inputId) {
	let input = document.getElementById(inputId);
	const plusBtn = document.querySelector(`[data-qtty-plus="${inputId}"]`);

	if (delta === -1 && input.value === "1") {
		return;
	} else {
		var newValue = parseInt(input.value, 10) + parseInt(delta, 10);

		// Vérification si la nouvelle valeur atteint ou dépasse le maximum autorisé
		if (input.max && newValue >= parseInt(input.max, 10)) {
			newValue = parseInt(input.max, 10); // Limiter à la valeur maximale
			plusBtn.setAttribute("disabled", "true"); // Désactiver le bouton "+"
		} else {
			plusBtn.removeAttribute("disabled"); // Réactiver le bouton "+" si on est en dessous de la limite
		}

		// Mise à jour de la valeur de l'input
		input.value = newValue;

		// Mise à jour des prix en fonction de la nouvelle quantité
		mmUpdatePrice(newValue);
	}
}

/*********************************************************************************************
 * Update the displayed prices based on the new quantity.
 *
 * @param {number} qtty - The current product quantity used to calculate the prices.
 */
function mmUpdatePrice(qtty) {
	var priceAll = document.querySelectorAll("[data-price]");
	var comparePriceAll = document.querySelectorAll("[data-compare-price]");

	// Met à jour les prix normaux
	priceAll.forEach(function (price) {
		var priceValue = parseFloat(price.dataset.price);
		if (!isNaN(priceValue)) {
			price.innerHTML = ((priceValue * qtty) / 100).toFixed(2) + "€";
		} else {
			console.error("Valeur de prix non valide : ", price.dataset.price);
		}
	});

	// Met à jour les prix comparatifs
	comparePriceAll.forEach(function (comparePrice) {
		var comparePriceValue = parseFloat(comparePrice.dataset.comparePrice);
		if (!isNaN(comparePriceValue)) {
			comparePrice.innerHTML = ((comparePriceValue * qtty) / 100).toFixed(2) + "€";
		} else {
			console.error("Valeur de prix comparatif non valide : ", comparePrice.dataset.comparePrice);
		}
	});
}

/*********************************************************************************************
 * Class for handling variant selection
 *
 */
class VariantSelector extends HTMLElement {
	constructor() {
		super();
		this.cached = {};
		this.container = this.closest("#product-form");
		this.addEventListener("change", this.onVariantChange.bind(this));
	}

	/*********************************************************************************************
	 * Handle variant change event.
	 *
	 */
	onVariantChange() {
		this.getSelectedOptions();
		this.getSelectedVariant();

		if (this.currentVariant) {
			this.updateURL();
			if (this.dataset.imageVariant) {
				this.updateImagesVariant();
			} else {
				this.updateMedia();
			}
			this.variantFetch();
		}
	}

	/*********************************************************************************************
	 * Get selected options from the variant checkboxes.
	 *
	 */
	getSelectedOptions() {
		this.options = Array.from(this.querySelectorAll(".mm-product-variant-checkbox:checked"), (checkbox) => checkbox.value);
	}

	/*********************************************************************************************
	 * Get variant data from the embedded JSON.
	 *
	 * @returns {Object} - The variant data.
	 */
	getVariantJSON() {
		this.variantData = JSON.parse(this.querySelector('[type="application/json"]').textContent);
		return this.variantData;
	}

	/*********************************************************************************************
	 * Get the selected variant based on selected options.
	 *
	 */
	getSelectedVariant() {
		this.currentVariant = this.getVariantJSON().find((variant) => {
			const findings = !variant.options
				.map((option, index) => {
					return this.options[index] === option;
				})
				.includes(false);

			if (findings) return variant;
		});
	}

	/*********************************************************************************************
	 * Update the URL to include the selected variant ID.
	 *
	 */
	updateURL() {
		window.history.replaceState({}, "", `${this.dataset.url}?variant=${this.currentVariant.id}`);
	}

	/*********************************************************************************************
	 * Fetch variant data from the server and cache it.
	 *
	 */
	variantFetch() {
		var variantUrl = `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`;

		if (this.cached[variantUrl]) {
			this.renderVariantInfo(this.cached[variantUrl]);
			return;
		}

		fetch(variantUrl)
			.then((response) => response.text())
			.then((responseText) => {
				const html = new DOMParser().parseFromString(responseText, "text/html");
				this.cached[variantUrl] = html;
				this.renderVariantInfo(html);
			})
			.catch((e) => {
				console.error(e);
			});
	}

	/*********************************************************************************************
	 * Render variant information in the DOM.
	 *
	 * @param {Document} html - The HTML document containing the variant information.
	 */
	renderVariantInfo(html) {
		this.updateElementOuter("#product_id", html);
this.updateElementOuter(".mm-product-price", html);
this.updateMultipleElement(".mm-product-form-variant-value", html);
this.updateMultipleElementOuter(".mm-product-form-component-cta", html);
this.updateElementOuter(".mm-product-availability", html);
this.updateElementOuter(".mm-media-pills", html);
this.updateElementOuter(".mm-product-sticky-variant-selector-size", html);
this.updateElementOuter(".mm-find-in-store-shops", html);
		this.updateImagesVariant();
		syncVariantRadios();

		setTimeout(() => {
			document.querySelectorAll(".mm-product-variant-checkbox").forEach((input) => {
				if (input.hasAttribute("checked")) {
					input.checked = true;
				} else {
					input.checked = false;
				}
			});
		}, 100);

		initializeStickyCTA();
	}

	/*********************************************************************************************
	 * Update the inner HTML of an element.
	 *
	 * @param {string} selector - The CSS selector of the element to update.
	 * @param {HTMLElement} html - The HTML element containing the new content.
	 */
	updateElement(selector, html) {
		const destination = this.container.querySelector(selector);
		const source = html.querySelector(selector);
		if (source && destination) destination.innerHTML = source.innerHTML;
	}

	/*********************************************************************************************
	 * Update the outer HTML of an element.
	 *
	 * @param {string} selector - The CSS selector of the element to update.
	 * @param {HTMLElement} html - The HTML element containing the new content.
	 */
	updateElementOuter(selector, html) {
		const destination = this.container.querySelector(selector);
		const source = html.querySelector(selector);
		if (source && destination) destination.outerHTML = source.outerHTML;
	}
updateMultipleElementOuter(selector, html) {
	const destinations = this.container.querySelectorAll(selector);
	const sources = html.querySelectorAll(selector);

	destinations.forEach((destination, index) => {
		if (sources[index]) {
			destination.outerHTML = sources[index].outerHTML;
		}
	});
}
	/*********************************************************************************************
	 * Update the outer HTML of multiple elements.
	 *
	 * @param {string} selector - The CSS selector of the element to update.
	 * @param {HTMLElement} html - The HTML element containing the new content.
	 */
	updateMultipleElement(selector, html) {
		const destination = this.container.querySelectorAll(selector);
		const source = html.querySelectorAll(selector);

		if (source && destination) {
			for (let index = 0; index < source.length; index++) {
				// Check if destination element exists before trying to update
				if (destination[index]) {
					destination[index].outerHTML = source[index].outerHTML;
				}
			}
		}
	}

	/*********************************************************************************************
	 * Update the media carousel to display the featured media of the current variant.
	 *
	 */
	updateMedia() {
		if (this.currentVariant && this.currentVariant.featured_media) {
			var variant_media_id = this.currentVariant.featured_media.id;
			var allMainMedia = document.querySelectorAll(".mm-product-medias .splide__slide");

			allMainMedia.forEach((media, index) => {
				if (media.dataset.id != null && parseInt(media.dataset.id) == variant_media_id) {
					splideMainInstance.go(index);
				}
			});
		}
	}

	/*********************************************************************************************
	 * Update the visibility of the media sliders for the current variant.
	 *
	 */
	updateImagesVariant() {
		var allMainMedia = document.querySelectorAll(".main-slider-variant");
		allMainMedia.forEach((media) => {
			if (media.dataset.variantid == this.currentVariant.id) {
				media.style.display = "flex";
			} else {
				media.style.display = "none";
			}
		});
		var allThumbnailMedia = document.querySelectorAll(".thumbnail-slider-variant");
		allThumbnailMedia.forEach((media) => {
			if (media.dataset.variantid == this.currentVariant.id) {
				media.style.display = "flex";
			} else {
				media.style.display = "none";
			}
		});
	}
}

/*********************************************************************************************
 * Define the custom element
 *
 */
customElements.define("variant-selector", VariantSelector);

/*********************************************************************************************
 * Read-more x Read-less
 *
 */
function mmReadMore() {
	const toggle = document.getElementById("read-more-toggle");
	const truncated = document.querySelector(".mm-description-truncated");
	const full = document.querySelector(".mm-description-full");
	const container = document.querySelector(".mm-product-description");
	if (!toggle || !truncated || !full || !container) return;

	toggle.addEventListener("click", function () {
		const seeMore = container.getAttribute("data-see-more");
		const seeLess = container.getAttribute("data-see-less");
		if (full.style.display === "none") {
			truncated.style.display = "none";
			full.style.display = "";
			toggle.textContent = seeLess;
		} else {
			truncated.style.display = "";
			full.style.display = "none";
			toggle.textContent = seeMore;
		}
	});
}

/*********************************************************************************************
 * Custom select
 *
 */
function mmCustomSelect() {
	const select = document.querySelector(".custom-select");
	if (!select) {
		return;
	}

	const trigger = select.querySelector(".custom-select-trigger");
	if (!trigger) {
		return;
	}

	// Ouvrir/fermer le sélecteur
	trigger.addEventListener("click", function () {
		select.classList.toggle("open");
	});

	// Fermer si on clique en dehors
	document.addEventListener("click", function (e) {
		if (!select.contains(e.target)) {
			select.classList.remove("open");
		}
	});
}

/*********************************************************************************************
 * Shop the Look Modal functionality
 *
 */
function mmShopTheLook() {
	// Open modal
	const shopTheLookTriggers = document.querySelectorAll("[data-shop-the-look-trigger]");
	var productForm = document.querySelector(".mm-media-container");
	shopTheLookTriggers.forEach((trigger) => {
		trigger.addEventListener("click", function () {
			const productId = this.dataset.shopTheLookTrigger;
			const modal = document.querySelector(`#ShopTheLookModal-${productId}`);
			if (modal) {
				modal.classList.add("is-active");
				document.body.style.overflow = "hidden";
				productForm.style.zIndex = "14";
				// Marqueur pour masquer la barre d'achat fixe de la page produit
				// tant que la modale est ouverte (equivalent JS de :has(), pour les
				// navigateurs qui ne supportent pas :has(), ex. anciens iOS Safari).
				document.body.classList.add("mm-stl-open");
			}
		});
	});

	// Close modal
	const closeButtons = document.querySelectorAll(".mm-modal-close, .mm-modal-overlay");
	closeButtons.forEach((button) => {
		button.addEventListener("click", function () {
			const modal = this.closest(".mm-modal");
			if (modal) {
				modal.classList.remove("is-active");
				document.body.style.overflow = "";
				productForm.style.zIndex = "2";
				document.body.classList.remove("mm-stl-open");
			}
		});
	});

	// Fermeture au clic sur l'overlay (élément after)
	const modals = document.querySelectorAll(".mm-shop-the-look-modal");
	modals.forEach((modal) => {
		modal.addEventListener("click", function (event) {
			// Si le clic est sur la modale elle-même (l'overlay) et non sur son contenu
			if (event.target === this) {
				this.classList.remove("is-active");
				document.body.style.overflow = "";
				productForm.style.zIndex = "2";
				document.body.classList.remove("mm-stl-open");
			}
		});
	});
}

/*********************************************************************************************
 * Size advice functionality
 *
 */
function mmSizeAdvice() {
	// Open modal
	const sizeAdvices = document.querySelectorAll("[data-size-advice-trigger]");
	var productForm = document.querySelector(".mm-product-form");
	sizeAdvices.forEach((trigger) => {
		trigger.addEventListener("click", function () {
			const productId = this.dataset.sizeAdviceTrigger;
			console.log(productId);
			const modal = document.querySelector(`#SizeAdvice-${productId}`);
			if (modal) {
				modal.classList.add("is-active");
				document.body.style.overflow = "hidden";
				productForm.style.zIndex = "14";
			}
		});
	});

	// Close modal
	const closeButtons = document.querySelectorAll(".mm-icon-close, .mm-size-advice-modale-cta");
	closeButtons.forEach((button) => {
		button.addEventListener("click", function () {
			const modal = this.closest(".mm-modal");
			if (modal) {
				modal.classList.remove("is-active");
				document.body.style.overflow = "";
				productForm.style.zIndex = "1";
			}
		});
	});

	// Fermeture au clic sur l'overlay (élément after)
	const modals = document.querySelectorAll(".mm-size-advice-modale");
	modals.forEach((modal) => {
		modal.addEventListener("click", function (event) {
			// Si le clic est sur la modale elle-même (l'overlay) et non sur son contenu
			if (event.target === this) {
				this.classList.remove("is-active");
				document.body.style.overflow = "";
				productForm.style.zIndex = "1";
			}
		});
	});
}

/*********************************************************************************************
 * Product Card Variant Selection
 *
 */
function initializeVariantSelectors() {
	const variantSelectors = document.querySelectorAll("[data-card-variant-selector]");

	variantSelectors.forEach((select) => {
		select.addEventListener("change", function (event) {
			const selectedVariant = event.target.options[event.target.selectedIndex];
			const selectedId = selectedVariant.value;
			const productCard = this.closest(".mm-product-card");
			const addToCartButton = productCard.querySelector(".mm-product-card-add-to-cart");
			const priceElement = productCard.querySelector(".mm-pr-price span");
			const comparePriceElement = productCard.querySelector(".mm-pr-price-compare");

			// Récupérer les données du variant
			const variantData = JSON.parse(document.getElementById(`ProductVariantJSON-${this.dataset.cardVariantSelector}`).textContent);
			const selectedVariantData = variantData.find((v) => v.id.toString() === selectedId);

			if (selectedVariantData) {
				// Mise à jour du prix
				if (priceElement) {
					const priceFormatted = selectedVariantData.price / 100;
					let euros = Math.floor(priceFormatted);
					let cents = Math.round((priceFormatted - euros) * 100);
					priceElement.innerHTML = euros + "€" + (cents > 0 ? cents : "");
				}

				// Mise à jour du prix barré
				if (comparePriceElement && selectedVariantData.compare_at_price) {
					const compareFormatted = selectedVariantData.compare_at_price / 100;
					let euros = Math.floor(compareFormatted);
					let cents = Math.round((compareFormatted - euros) * 100);
					comparePriceElement.innerHTML = `<s>${euros}€${cents > 0 ? cents : ""}</s>`;
					comparePriceElement.style.display = selectedVariantData.compare_at_price > selectedVariantData.price ? "" : "none";
				}

				// Mise à jour du bouton d'ajout au panier
				if (addToCartButton) {
					addToCartButton.disabled = !selectedVariantData.available;
					addToCartButton.dataset.variantId = selectedId;
				}
			}
		});
	});
}

/*********************************************************************************************
 * Splide reassurance - Initialisation
 *
 */
function initializeSplideReassurance(splideElem) {
	var splideInstance = new Splide(splideElem, {
		type: "loop",
		arrows: false,
		pagination: true,
		perPage: 1,
		drag: "free",
		snap: true,
		fixedWidth: "100%",
		autoplay: true,
		interval: 4000,
		pauseOnHover: false,
		breakpoints: {
			768: {},
		},
	}).mount();

	// Ajout de l'écouteur d'événement pour le défilement horizontal
	addHorizontalScrollListener(splideElem, splideInstance);
}

/*********************************************************************************************
 * Sync variant radios
 *
 */
function syncVariantRadios() {
	document.querySelectorAll(".mm-product-variant-checkbox").forEach((input) => {
		// Pour éviter d'ajouter plusieurs fois le même listener
		if (input.dataset.syncListener) return;
		input.dataset.syncListener = "1";
		input.addEventListener("change", function () {
			if (this.dataset.syncing) return;
			const group = document.querySelectorAll(`.mm-product-variant-checkbox[name="${this.name}"]`);
			group.forEach((otherInput) => {
				if (otherInput !== this) {
					otherInput.dataset.syncing = "1";
					otherInput.checked = otherInput.value === this.value;
					if (otherInput.checked) {
						otherInput.dispatchEvent(new Event("change", { bubbles: true }));
					}
					delete otherInput.dataset.syncing;
				}
			});
		});
	});
}

/*********************************************************************************************
 * Regroupe la logique de synchronisation de l'iframe Klaviyo BIS dans une fonction dédiée
 *
 */
function initializeKlaviyoBISSync() {
	// Fonction utilitaire pour attendre l'apparition de #container dans l'iframe
	function waitForIframeContainer(iframe, productWrapperWidth, isSticky = false, maxAttempts = 20, interval = 100) {
		let attempts = 0;
		function trySetWidth() {
			if (!iframe.contentWindow || !iframe.contentWindow.document) {
				if (++attempts < maxAttempts) setTimeout(trySetWidth, interval);
				return;
			}
			let containerElement;
			let modalElement;
			try {
				containerElement = iframe.contentWindow.document.getElementById("container");
				modalElement = iframe.contentWindow.document.getElementById("klaviyo-bis-modal");
			} catch (e) {
				// Cross-origin ou autre erreur
				if (++attempts < maxAttempts) setTimeout(trySetWidth, interval);
				return;
			}
			if (containerElement && modalElement) {
				iframe.style.pointerEvents = "auto";
				var bisBtn = document.querySelector(".klaviyo-bis-trigger");
				var waxBtn = document.querySelector('[onclick*="waxOpenBackInStockModal"]');
				if (bisBtn) bisBtn.style.visibility = "hidden";
				containerElement.style.width = productWrapperWidth + "px";
				if (window.innerWidth <= 990) {
					containerElement.style.padding = isSticky ? "0 12px" : "";
					// Appliquer le background sur #klaviyo-bis-modal
					modalElement.style.background = isSticky ? "white" : "transparent";
				} else {
					containerElement.style.padding = "";
					modalElement.style.background = "transparent";
				}
				// Injecter le CSS newsletter + patch FR + hauteur
				var iframeDoc = iframe.contentWindow.document;
				if (!iframeDoc.getElementById("flair-newsletter-css")) {
					var nlStyle = iframeDoc.createElement("style");
					nlStyle.id = "flair-newsletter-css";
					nlStyle.textContent = "#container div:has(#subscribe_for_newsletter){display:flex!important;align-items:center;gap:6px;margin-top:10px;margin-bottom:0}#container p:has(#subscribe_for_newsletter){display:flex!important;align-items:center;gap:6px;margin-top:0;margin-bottom:0}label[for='subscribe_for_newsletter']{display:inline!important;font-size:11px;color:#1d1d1b;cursor:pointer;margin-left:0}";
					iframeDoc.head.appendChild(nlStyle);
					setTimeout(function() {
						var cb = iframeDoc.getElementById("subscribe_for_newsletter");
						if (cb) cb.checked = false;
						var lbl = iframeDoc.querySelector("label[for='subscribe_for_newsletter']");
						if (lbl) lbl.textContent = (window.mmStrings && window.mmStrings.bisNewsletter) || "M’abonner à la newsletter Flair";
						var submitBtn2 = iframeDoc.querySelector(".btn-success");
if (submitBtn2 && !submitBtn2.dataset.flairConsentListener) {
    submitBtn2.dataset.flairConsentListener = "1";
    submitBtn2.addEventListener("click", function() {
        var cb2 = iframeDoc.getElementById("subscribe_for_newsletter");
        var emailInput = iframeDoc.querySelector("input[type='email']");
        if (cb2 && cb2.checked && emailInput && emailInput.value) {
            window._learnq = window._learnq || [];
            window._learnq.push(["identify", {
                "$email": emailInput.value,
                "$consent": ["email"],
                "subscribe_for_newsletter": true
            }]);
        }
    });
}
						var submitBtn = iframeDoc.querySelector(".submit-container");
						if (submitBtn) {
							var bottomOfContent = submitBtn.offsetTop + submitBtn.offsetHeight;
iframe.style.height = (bottomOfContent + 2) + "px";
						iframe.dataset.newsletterHeightSet = "1";
						}
					}, 150);
				}
			} else if (++attempts < maxAttempts) {
				setTimeout(trySetWidth, interval);
			} else {
				console.log("Élément #container non trouvé dans l'iframe après plusieurs tentatives.");
			}
		}
		trySetWidth();
	}

	function synchronizePositions() {
		var element = document.querySelector(".mm-product-form-component-cta-initial");
		var productForm = document.querySelector(".mm-product-form");
		var productWrapper = document.querySelector(".mm-product-form-container");
		var iframeElement = document.getElementById("klaviyo-bis-iframe");
		var stickyCTA = document.querySelector(".mm-product-sticky-cta-container");

		if (!element || !productWrapper || !iframeElement || !stickyCTA) {
			return;
		}

		let isSticky = !stickyCTA.classList.contains("mm-none");

		// Si le sticky CTA est visible, on applique le style sticky à l'iframe
		if (isSticky) {
			iframeElement.classList.add("sticky-cta-visible");
			iframeElement.style.position = "sticky";
			iframeElement.style.top = "unset";
			iframeElement.style.bottom = "0";
			iframeElement.style.left = "0";
			iframeElement.style.right = "0";
			iframeElement.style.width = "100vw";
			iframeElement.style.zIndex = "100";
			iframeElement.style.height = "117px";
			iframeElement.style.padding = "0 0 8px 0";
			iframeElement.style.background = "white";
		} else {
			// Sinon, style normal
			var rect = element.getBoundingClientRect();
			var topPosition = rect.top + window.scrollY;
			var isMobile = window.innerWidth <= 990;

			iframeElement.classList.remove("sticky-cta-visible");
			iframeElement.style.position = isMobile ? "absolute" : "fixed";
			iframeElement.style.top = topPosition + "px";
			iframeElement.style.bottom = "unset";
			iframeElement.style.left = "";
			iframeElement.style.right = "";
			iframeElement.style.width = "100%";
			iframeElement.style.zIndex = "1";
iframeElement.style.pointerEvents = "none";
if (!iframeElement.dataset.newsletterHeightSet) {
    iframeElement.style.height = "86px";
}
			iframeElement.style.padding = "0px";
			iframeElement.style.background = "transparent";
		}

		// Ajoute un écouteur 'load' pour relancer le calcul à chaque rechargement de l'iframe
		if (!iframeElement.dataset.klaviyoBisLoadListener) {
			iframeElement.addEventListener("load", function onIframeLoad() {
    delete iframeElement.dataset.newsletterHeightSet;
    var productWrapper = document.querySelector(".mm-product-form-container");
				if (productWrapper) {
					var productWrapperWidth = productWrapper.getBoundingClientRect().width;
					waitForIframeContainer(iframeElement, productWrapperWidth, isSticky);
				}
			});
			iframeElement.dataset.klaviyoBisLoadListener = "1";
		}

		// Attendre que le DOM de l'iframe soit prêt et que #container existe
		var productWrapperWidth = productWrapper.getBoundingClientRect().width;
		waitForIframeContainer(iframeElement, productWrapperWidth, isSticky);
	}

	// Observer pour détecter quand l'iframe est ajouté au DOM
	const observer = new MutationObserver((mutations) => {
		mutations.forEach((mutation) => {
			mutation.addedNodes.forEach((node) => {
				if (node.id === "klaviyo-bis-iframe") {
					synchronizePositions();
				}
			});
		});
	});

	// Observer le document pour détecter l'ajout de l'iframe
	observer.observe(document.body, {
		childList: true,
		subtree: true,
	});

	// Observer l'ouverture du modal contenant l'iframe
	const modal = document.querySelector(".mm-find-in-store-popup-container"); // adapte le sélecteur si besoin
	if (modal) {
		const modalObserver = new MutationObserver((mutations) => {
			mutations.forEach((mutation) => {
				if (mutation.attributeName === "class" && modal.classList.contains("open")) {
					synchronizePositions();
					setTimeout(synchronizePositions, 100);

					// Correction : recalcul du top en desktop
					if (window.innerWidth > 990) {
						const element = document.querySelector(".mm-product-form-component-cta-initial");
						const iframeElement = document.getElementById("klaviyo-bis-iframe");
						if (element && iframeElement) {
							const rect = element.getBoundingClientRect();
							const topPosition = rect.top + window.scrollY;
							iframeElement.style.top = topPosition + "px";
						}
					}
				}
			});
		});
		modalObserver.observe(modal, { attributes: true });
	}



	// Cacher l'iframe quand on change vers une variante en stock
	// On observe le parent du cta-initial car son outerHTML est remplacé
	var ctaParentObserver = new MutationObserver(function() {
		setTimeout(function() {
			var iframeEl = document.getElementById("klaviyo-bis-iframe");
			var bisBtn = document.querySelector(".klaviyo-bis-trigger");
			var waxBtn = document.querySelector('[onclick*="waxOpenBackInStockModal"]');
			if (iframeEl && !bisBtn) {
				iframeEl.style.display = "none";
			} else {
				if (bisBtn) bisBtn.style.visibility = "visible";
				if (waxBtn) waxBtn.style.visibility = "visible";
			}
		}, 100);
	});
	var ctaParent = document.querySelector(".mm-product-form-container");
	if (ctaParent) {
		ctaParentObserver.observe(ctaParent, {childList: true, subtree: false});
	}

	if (window.innerWidth > 990) {
		window.addEventListener("resize", function () {
			const modal = document.querySelector(".mm-find-in-store-popup-container");
			const iframeElement = document.getElementById("klaviyo-bis-iframe");
			if (modal && iframeElement && modal.classList.contains("open")) {
				const element = document.querySelector(".mm-product-form-component-cta-initial");
				if (element) {
					const rect = element.getBoundingClientRect();
					const topPosition = rect.top + window.scrollY;
					iframeElement.style.top = topPosition + "px";
				}
			}
		});
	}

	syncModalWithStickyCTA();
}

/*********************************************************************************************
 * Sync modal with sticky CTA
 *
 */
function syncModalWithStickyCTA() {
	const stickyCTA = document.querySelector(".mm-product-sticky-cta-container");
	const iframeElement = document.getElementById("klaviyo-bis-iframe");
	const ctaInitial = document.querySelector(".mm-product-form-component-cta-initial");
	const productWrapper = document.querySelector(".mm-product-form-container");

	if (!stickyCTA || !iframeElement) return;

	function setStickyStyle() {
		iframeElement.style.position = "sticky";
		iframeElement.style.top = "unset";
		iframeElement.style.bottom = "0";
		iframeElement.style.left = "0";
		iframeElement.style.right = "0";
		iframeElement.style.width = "100vw";
		iframeElement.style.zIndex = "100";
	}

	function setNormalStyle() {
		if (!ctaInitial || !productWrapper) return;
		const rect = ctaInitial.getBoundingClientRect();
		const topPosition = rect.top + window.scrollY;
		iframeElement.style.position = "absolute";
		iframeElement.style.top = topPosition + "px";
		iframeElement.style.bottom = "unset";
		iframeElement.style.left = "";
		iframeElement.style.right = "";
		iframeElement.style.width = "100%";
		iframeElement.style.zIndex = "1";
	}

	const updateModalStyle = () => {
		if (!stickyCTA.classList.contains("mm-none")) {
			setStickyStyle();
		} else {
			setNormalStyle();
		}
	};

	// Observe sticky CTA visibility
	const observer = new MutationObserver(updateModalStyle);
	observer.observe(stickyCTA, { attributes: true, attributeFilter: ["class"] });

	// Initial sync
	updateModalStyle();
}

/*********************************************************************************************
 * Loaded Listenner
 *
 */
document.addEventListener("DOMContentLoaded", () => {
	mmCustomSelect();
	mmShopTheLook();
	mmSizeAdvice();
	mmReadMore();
	mmSlideProductReassurance();
	initializeStickyCTA();
	initializeVariantSelectors();
	initializeSectionsWithSplide("data-section-id", ".mm-product-form-component-reassurance-splide", initializeSplideReassurance);
	syncVariantRadios();
	initializeKlaviyoBISSync();
});